import Div from '@/shared/Div';
import React, { memo } from 'react';
import Paragraph from '@/shared/Paragraph';
import Span from '@/shared/Span';
import Heading from '@/shared/Heading';
import SingleStarIcon from '@/components/Icons/SingleStar';

const ProductTitle = ({
  productName = '',
  ratingText = '4.5 Amazon ratings',
  dataTestId = 'product-name',
}: {
  productName?: string;
  selectedFilter?: string;
  ratingText?: string;
  dataTestId?: string;
}) => {
  return (
    <Div dataTestId={dataTestId}>
      {/* <Div className="hidden lg:block lg:flex ">
        <SingleStarIcon />
        <Span className=" text-body-lg text-black ">{ratingText}</Span>
      </Div> */}
      <Div
        className="text-h-1 lg:text-hd-1 text-cm-primary break-words"
        dangerouslySetInnerHTML={{ __html: productName }}
      />
    </Div>
  );
};

export default memo(ProductTitle);
